import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { pathgen } from 'object-path-generator';
import { Button, MenuItem, MenuPromotionalAction, SplitButton } from 'seagull';
import { useEventReporter } from '~/event-reporter';
import { useRedirectToProposal } from '~/hooks/useCreateAgreement';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useOpenNewProposal } from '~/hooks/useOpenNewProposal';
import { useLocaleKeys } from '~/i18n';
import styles from './CreateProposalButton.module.scss';
export const CreateProposalButtonTestIds = pathgen('CreateProposalButtonTestIds');
export const CreateProposalButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { t: cpTexts } = useLocaleKeys('components.createProposalButton');
    const { text = cpTexts.defaultText(), hideTemplatePicker = false, navigationState } = props;
    const { reportButtonClick } = useEventReporter();
    const { openCreationModal } = useRedirectToProposal();
    const { isLoadingProposalTemplates, hasProposalTemplates, openNewProposal: _openNewProposal, openSelectProposalTypeModal, openImportAgreement } = useOpenNewProposal({
        navigationState
    });
    const { AGREEMENT_FROM_PDF } = useFeatureFlags();
    const { t } = useLocaleKeys();
    function openNewProposal() {
        reportButtonClick('topbar-new-agreement-btn');
        _openNewProposal();
    }
    const openNewProposalFromDraft = async ()=>{
        reportButtonClick('topbar-new-agreement-btn');
        await openCreationModal({
            state: navigationState
        });
    };
    const onNewTemplate = async ()=>{
        openSelectProposalTypeModal('template');
    };
    return !hideTemplatePicker && hasProposalTemplates ? /*#__PURE__*/ _jsx(SplitButton, {
        label: text,
        testId: CreateProposalButtonTestIds.SplitButton.Root(),
        onClick: openNewProposal,
        popperClassName: styles.popper,
        flushBottom: AGREEMENT_FROM_PDF,
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(MenuItem, {
                    onClick: onNewTemplate,
                    testId: CreateProposalButtonTestIds.SplitButton.NewTemplateOption(),
                    children: cpTexts.useTemplate()
                }),
                /*#__PURE__*/ _jsx(MenuItem, {
                    onClick: openNewProposalFromDraft,
                    testId: CreateProposalButtonTestIds.SplitButton.NewProposalOption(),
                    children: cpTexts.startFromScratch()
                }),
                AGREEMENT_FROM_PDF && /*#__PURE__*/ _jsx(MenuPromotionalAction, {
                    title: t.agreementImport.menuItem.title(),
                    body: t.agreementImport.menuItem.body(),
                    testId: CreateProposalButtonTestIds.SplitButton.ImportAgreementOption(),
                    bi: {
                        name: 'import_agreement'
                    },
                    onClick: openImportAgreement
                })
            ]
        })
    }) : /*#__PURE__*/ _jsx(Button, {
        bi: {
            name: 'create_proposal'
        },
        testId: CreateProposalButtonTestIds.Button(),
        onClick: openNewProposal,
        ref: ref,
        loading: isLoadingProposalTemplates,
        children: text
    });
});
